import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { StoreState } from '@mm/state/store-interfaces';
import './NewEntityButton.scss';
import { welcomePageSelector } from '@mm/state/selectors/onboardingSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { PrimaryButton } from '../../../common/buttons/PrimaryButton/PrimaryButton';

// Assumes need for botId and page.
// Could be easily refactored into a more general one if needed

type OuterProps = {
  createEntity: (chatBotId: number, newEntity: any, fbPageId?: number) => void;
  name: string;
  text: string;
  extraFields?: any;
  fbPageId?: number;
  disabled?: boolean;
};
type InnerProps = ReturnType<typeof mapStateToProps>;
type Props = InnerProps & OuterProps;

const NewEntityButton = ({
  pages,
  createEntity,
  name,
  text,
  extraFields,
  fbPageId,
  chatbotId,
  welcomePage,
  disabled,
}: Props) => {
  const newEntity = {
    name,
    pageId: get(welcomePage || (pages && pages[0]), 'id', null),
    ...extraFields,
  };
  const CustomCreateEntity = fbPageId
    ? () => createEntity(chatbotId, newEntity, fbPageId)
    : () => createEntity(chatbotId, newEntity);

  return (
    <PrimaryButton
      onClick={CustomCreateEntity}
      className="new-entity-button"
      disabled={disabled}
    >
      <i className="fa fa-magic" /> {text}
    </PrimaryButton>
  );
};

const mapStateToProps = (state: StoreState) => ({
  pages: state.page.entities,
  welcomePage: welcomePageSelector(state),
  chatbotId: activeChatbotIdSelector(state),
});

const enhance = compose<InnerProps, OuterProps>(connect(mapStateToProps));

// Consider deprecate
export default enhance(NewEntityButton);
